
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.785 24.392c-3.314 5.74-10.653 7.706-16.393 4.393C6.652 25.47 4.686 18.132 8 12.392S18.653 4.686 24.392 8","stroke":"#424242","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M28.671 9.78l-3.416-3.914-1.682 4.916L28.67 9.78z","fill":"#424242"}})])
          )
        }
      }
    